var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-bg"},[_c('v-progress-circular',{attrs:{"size":"32","indeterminate":"","color":"gray lighten-2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }